/**
* Multi Image Hero JS
* -----------------------------------------------------------------------------
*
* All the JS for the Multi Image Hero component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';

( function( app ) {
  const COMPONENT = {

    className: 'multi-image-hero',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.multi-image-hero__slider' ).length ) {
        $( '.multi-image-hero__slider' ).each( function( index, element ) {
          const mainSplide = new Splide( element, {
            type: 'fade',
            rewind: true,
            gap: '2rem',
            perMove: 1,
            pagination: false,
            speed: 2000,
          } );

          mainSplide.on( 'overflow', function( isOverflow ) {
            mainSplide.options = {
              arrows: isOverflow,
              drag: isOverflow,
            };
          } );

          mainSplide.on( 'ready', function( ) {
            const slides = mainSplide.Components.Slides.get();
            slides.forEach( ( slide, index )=>{
              $( slide.slide ).addClass( 'is-mounted' );
              if ( index === 1 ) {
                $( slide.slide ).addClass( 'rotate-next' );
              }
              if ( index === 2 ) {
                $( slide.slide ).addClass( 'rotate-next-next' );
              }
            } );
          } );

          mainSplide.on( 'move', function( newIndex, prevIndex, destIndex ) {
            $( '.splide__slide' ).removeClass( 'rotate-next' );
            $( '.splide__slide' ).removeClass( 'rotate-next-next' );
            const slides = mainSplide.Components.Slides.get();
            const nextSlideIndex = newIndex === ( slides.length - 1 ) ? 0 : newIndex + 1;
            const nextNextSlideIndex = nextSlideIndex === ( slides.length - 1 ) ? 0 : nextSlideIndex + 1;

            $( slides[nextSlideIndex].slide ).addClass( 'rotate-next' );
            $( slides[nextNextSlideIndex].slide ).addClass( 'rotate-next-next' );
          } );


          mainSplide.mount();
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'multi-image-hero', COMPONENT );
} )( app );
